<template>
  <div class="h-auto self-start flex flex-col">
    <!-- Breadcrumbs skeleton -->
    <div class="loading-effect breadcrumbs w-1/2 md:w-2/12 h-[20px]"></div>

    <!-- Magazine header skeleton -->
    <div class="mt-4 mb-6">
      <div class="loading-effect title w-1/3 h-[32px] mb-4"></div>

      <!-- Category links skeleton -->
      <div class="flex flex-wrap gap-2 mb-4">
        <div class="loading-effect w-20 h-8 rounded-full"></div>
        <div class="loading-effect w-24 h-8 rounded-full"></div>
        <div class="loading-effect w-16 h-8 rounded-full"></div>
        <div class="loading-effect w-28 h-8 rounded-full"></div>
        <div class="loading-effect w-22 h-8 rounded-full"></div>
      </div>
    </div>

    <!-- Article list skeleton -->
    <MagazineHomePaginatedContentSkeleton />
  </div>
</template>

<script setup lang="ts">
import MagazineHomePaginatedContentSkeleton from '~/components/magazine/home/MagazineHomePaginatedContentSkeleton.vue'
</script>

<style lang="postcss" scoped>
@import '~/assets/css/loading.css';
</style>
